import type { TopCompetitor } from '@ekorank/shared'

interface Props {
  competitors: TopCompetitor[]
}

export function CompetitorShareOfVoice({ competitors }: Props) {
  if (competitors.length === 0) {
    return (
      <div className="bg-surface-container rounded-xl border border-outline-variant/10 p-4 sm:p-6 mb-6 sm:mb-10">
        <h3 className="text-sm font-mono text-outline uppercase tracking-widest mb-1">Top Competitors</h3>
        <p className="text-on-surface-variant text-sm mt-4">No competitors mentioned yet.</p>
      </div>
    )
  }
  const max = Math.max(...competitors.map((c) => c.sharePct), 1)

  return (
    <div className="bg-surface-container rounded-xl border border-outline-variant/10 p-4 sm:p-6 mb-6 sm:mb-10">
      <h3 className="text-sm font-mono text-outline uppercase tracking-widest mb-1">Top Competitors</h3>
      <p className="text-xs text-outline mb-6">% of your checks where each competitor appears</p>
      <ul className="space-y-3">
        {competitors.map((c) => (
          <li key={c.normalizedName} className="space-y-1.5">
            <div className="flex items-baseline justify-between gap-3">
              <p className="text-sm text-white truncate flex-1 capitalize">{c.name}</p>
              <p className="text-xs font-mono text-on-surface-variant whitespace-nowrap">
                {c.mentionCount} ({c.sharePct}%)
              </p>
            </div>
            <div className="h-2 rounded-full bg-surface-container-high overflow-hidden">
              <div className="h-full rounded-full bg-primary/70" style={{ width: `${(c.sharePct / max) * 100}%` }} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
